import { createSlice } from "@reduxjs/toolkit";
import { updateDoctorClinicSchedule } from "../../reducer/clinicSchedule/updateClinicScheduleReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const doctorClinicScheduleSlice = createSlice({
  name: "doctorClinicSchedule",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateDoctorClinicSchedule.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateDoctorClinicSchedule.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(updateDoctorClinicSchedule.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default doctorClinicScheduleSlice.reducer;
